import { render, staticRenderFns } from "./simplifyContractFee.vue?vue&type=template&id=efb83a2c&scoped=true"
import script from "./simplifyContractFee.vue?vue&type=script&lang=js"
export * from "./simplifyContractFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyContractFee.vue?vue&type=style&index=0&id=efb83a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb83a2c",
  null
  
)

export default component.exports